import { render, staticRenderFns } from "./CountyDetail.vue?vue&type=template&id=2d7310a8&scoped=true&"
import script from "./CountyDetail.vue?vue&type=script&lang=js&"
export * from "./CountyDetail.vue?vue&type=script&lang=js&"
import style0 from "./CountyDetail.vue?vue&type=style&index=0&id=2d7310a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7310a8",
  null
  
)

export default component.exports